export const phone_number = {
  name: 'phone-number',
  title: 'phone-number.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-phone-number.vue'),
  route: { name: 'phone-number.index' },
  children: [
    {
      title: 'phone-number.breadcrumb.number.buy',
      route: { name: 'phone-number.number.buy' }
    },
    {
      title: 'phone-number.breadcrumb.number.index',
      route: { name: 'phone-number.number.index' }
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'phone-number.stats.type', params: { type: 'general' } }
    }
  ]
};
